export const BASE_URL = process.env.REACT_APP_API_ROOT as string;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_ROOT as string;
export const JWT_SECRET = '1234' as string;
